export default __webpack_public_path__ + "static/media/faq-icon.dd83df7e.svg";